import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css/navigation';
import { FaLaptopCode } from 'react-icons/fa';
import css from './OurClients.css';

import client1 from '../assets/clients/React.svg';
import client2 from '../assets/clients/AWS.svg';
import client3 from '../assets/clients/MongoDB.svg';
import client4 from '../assets/clients/Nextjs.svg';
import client5 from '../assets/clients/Python.svg';
import client6 from '../assets/clients/Firebase.svg';
import client7 from '../assets/clients/Google Cloud.svg';
import client8 from '../assets/clients/pinecone.png';
const clients = [
  { logo: client1, name: 'React', description: ' JavaScript library for building user interfaces' },
  { logo: client2, name: 'AWS', description: 'Secure cloud infrastructure' },
  { logo: client3, name: 'MongoDB', description: ' flexible, scalable NoSQL cloud database' },
  { logo: client4, name: 'Nextjs', description: 'The React framework' },
  { logo: client5, name: 'Python', description: 'Build & integrate systems' },
  { logo: client6, name: 'Firebase', description: ' flexible, scalable NoSQL cloud database' },
  { logo: client7, name: 'Google Cloud', description: 'Secure cloud infrastructure' },
  { logo: client8, name: 'Pinecone', description: 'Secure Vector Database infrastructure' },
];

const OurClients = () => {
  // AOS is initialized globally in App.js

  return (
    <section className="home__clients-section">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <h2 className="home__clients-title" data-aos="fade-up" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <FaLaptopCode size={40} color="#8f69c8" />
          Technologies We Work With
        </h2>
        <p className="home__clients-subtitle" data-aos="fade-up" data-aos-delay="100">
          Empowering solutions with the latest in AI, cloud, mobile, and enterprise tech stacks.
        </p>
        <Swiper
          modules={[Navigation, Autoplay]}
          navigation={true}
          autoplay={{ delay: 3000 }}
          loop
          spaceBetween={15}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >

          {clients.map((client, index) => (
            <SwiperSlide key={index}>
              <div
                className="swiper-slide-content"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="client-logo-container">
                  <img src={client.logo} alt={client.name} />
                </div>
                <h4 className="text-lg font-semibold">{client.name}</h4>
                <p className="text-sm text-gray-500">{client.description}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default OurClients;
